import { App, AppState } from '@capacitor/app'
import { Subscription } from '@/service/subscription/Subscription'
import { PluginListenerHandleSubscription } from '@/service/subscription/PluginListenerHandleSubscription'

export function waitForAppToResume(): Promise<void> {
  return new Promise((resolve, reject) => {
    App.addListener('appStateChange', (appState: AppState) => {
      if (appState.isActive) {
        resolve()
      }
    }).catch(e => reject(e))
  })
}

export async function registerToAppState(callback: (appState: AppState) => void): Promise<Subscription> {
  const maybePromise = App.addListener('appStateChange', callback)
  const handle = typeof (maybePromise as Promise<any>).then === 'function'
    ? await (maybePromise as Promise<any>)
    : maybePromise
  return new PluginListenerHandleSubscription([handle])
}
